import { POSTGRES_MAX_INT } from '../util/math/number'
import { maxValue, minValue, nullable, number, optional, pipe, type InferOutput } from 'valibot'

export const ArmyPaintIdSchema = pipe(number(), minValue(1), maxValue(POSTGRES_MAX_INT))

export const OptionalNullableArmyPaintIdSchema = optional(nullable(ArmyPaintIdSchema))

export type ArmyPaintId = InferOutput<typeof ArmyPaintIdSchema>
